// extracted by mini-css-extract-plugin
module.exports = {"password_reset":"password-reset_password_reset__KbSkr","password_reset_form":"password-reset_password_reset_form__38SJ5"};